import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Form, Input, Button } from 'antd';
import { trim, capitalize } from 'lodash';
import styles from './index.scss';

const { TextArea } = Input;

export const RejectConfirmationModal = ({
  data,
  open,
  isModalOpen,
  onRejectConfirmed,
  approveAndRejectData,
  refreshPage = () => {}
}) => {
  const [form] = Form.useForm();
  const [reasonErrors, setReasonErrors] = useState('');
  const [values, setValues] = useState({
    reason: ''
  });

  const approveRejectStatus = approveAndRejectData?.isSuccess;

  useEffect(() => {
    if (approveAndRejectData?.isSuccess && refreshPage) {
      refreshPage();
      isModalOpen(false);
    }
  }, [approveRejectStatus]);

  const handleOk = () => {
    let params = {
      status: 'Rejected',
      reason: values.reason,
      ticketId: data?.id,
      championName: data?.itemName,
      runInstanceId: data?.challengerId
    };
    onRejectConfirmed(params);
  };

  const handleCancel = () => {
    isModalOpen(false);
  };

  const onBlur = (e) => {
    const { value } = e.target;
    if (value === '') {
      // for Required validation
      setReasonErrors(`Please input Reasons for Rejection`);
    }
  };

  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    setValues({ [name]: value });

    if (!!value && !/^[\p{L}\p{N}\p{M}]/u.test(value)) {
      // for space and special characters in starting of string
      setReasonErrors(
        capitalize(`${name} cannot start with space or special characters`)
      );
    } else if (!!value && !/^[\p{L}\p{N}\p{M}\s\-_,.]*$/u.test(value)) {
      setReasonErrors(`Supported special characters are _ - . , and space.`);
    } else if (value?.length < 15 || value?.length > 1000) {
      setReasonErrors(capitalize(`${name} must be 15-1000 characters.`));
    } else setReasonErrors('');
  };
  if (open !== false)
    return (
      <Modal
        title="Reject Promotion Request"
        visible={open}
        maskClosable={false}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            disabled={reasonErrors !== '' || !values?.reason}
            loading={approveAndRejectData.isLoading}
            onClick={handleOk}>
            Confirm
          </Button>
        ]}>
        <Form className={styles.form} initialValues={values} form={form}>
          <div style={{ maxWidth: '556px' }}>
            <label className={(styles.label, styles.required)}>
              Reasons for Rejection
            </label>
            <TextArea
              type="text"
              id={'rejectPromotionRequest-reason'}
              name="reason"
              className={styles.input}
              value={values.reason}
              onChange={onChangeHandler}
              onBlur={onBlur}
              placeholder="Reasons for Rejecting New Challenger"
              rows="5"
              cols="50"
              minLength={15}
              maxLength={1000}
            />
            <p className={styles.errorMessage} id="reasonError">
              {reasonErrors}
            </p>
          </div>
        </Form>
      </Modal>
    );
  else return null;
};

RejectConfirmationModal.defaultProps = {
  data: null,
  open: false,
  isModalOpen: null,
  onRejectConfirmed: null,
  approveAndRejectData: { isLoading: false, error: null, data: null }
};

RejectConfirmationModal.propTypes = {
  data: PropTypes.object,
  open: PropTypes.bool,
  isModalOpen: PropTypes.func,
  onRejectConfirmed: PropTypes.func,
  approveAndRejectData: PropTypes.object
};

export default RejectConfirmationModal;
